import React from 'react'

import { useDashboardPermissions } from '@components'
import { Suggestion } from '@components/common/Suggestion'
import { useCreatorSupportChannelsQuery } from '@queries/useCreatorSupportQuery'

import type { Recommendation } from '../../../Recommendations.types'
import bookACallImg from '../assets/book-a-call.webp'
import { BookACallButtons } from '../components/BookACallButtons/BookACallButtons'

export type BookACallRecommendation = {
  bookACallRecommendation: Recommendation
}

export const useBookACallRecommendation = (): BookACallRecommendation => {
  const { hasPermission } = useDashboardPermissions()
  const { getCreatorSupportChannelsQuery } = useCreatorSupportChannelsQuery()

  const isVisible =
    hasPermission('bookACall') &&
    getCreatorSupportChannelsQuery.isSuccess &&
    (!!getCreatorSupportChannelsQuery.data?.calendarUrl ||
      !!getCreatorSupportChannelsQuery.data?.email)

  const response = getCreatorSupportChannelsQuery?.data

  // NOTE: if you need in the future to use "GUIDED" creator logic, there is
  // const headline = response?.name === 'GUIDED' ? GUIDED_CALL_HEADLINE : NDR_HEADLINE

  return {
    bookACallRecommendation: {
      id: 'bookACall',
      enabled: isVisible,
      isLoading: getCreatorSupportChannelsQuery.isInitialLoading,
      suggestion: (
        <Suggestion
          title="Connect with your dedicated account manager"
          description="Book a call or email us. We'll make sure you're set up for success as you grow your creator business"
          analytics="bookACall"
          imageUrl={bookACallImg}
          content={<BookACallButtons calendarUrl={response?.calendarUrl} email={response?.email} />}
        />
      ),
    },
  }
}
